import { Box, Chip, Typography } from "@mui/material";

export const SURVEY_EMAIL_CONTENT_VARIABLES = [
  "firstName",
  "lastName",
  "studyName",
  "subjectId",
  "inviteUrl",
] as const;

export const SurveyEmailContentVariableChips = () => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 1 }}
      >
        Available variables for subject and body — click to copy
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
        {SURVEY_EMAIL_CONTENT_VARIABLES.map((v) => (
          <Chip
            key={v}
            label={`{{${v}}}`}
            size="small"
            onClick={() => navigator.clipboard.writeText(`{{${v}}}`)}
            sx={{ fontFamily: "monospace", cursor: "pointer" }}
          />
        ))}
      </Box>
    </Box>
  );
};
